var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerIconsShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 2,
    fill: "#878A99"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 19,
    height: 2,
    fill: "#8E91A0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 12,
    height: 2,
    fill: "#8E91A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIconsShow);
export default __webpack_public_path__ + "static/media/burgerIconsShow.e05fc7cf24b6fc7a84063238bb3b80e8.svg";
export { ForwardRef as ReactComponent };